module.exports = __webpack_public_path__ + "static/hero-cg-369788c0f41d8dc26238edf5a06c0ee8.png";